function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", null);

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M9.7.7C3.8 1.7.4 7 .5 14c0 1.6.3 3.2.9 4.6 1.4 2.8 4.4 4 7.1 4.5 2.9.5 6 .4 8.7-1 2.7-1.4 5-4.1 5.6-7.5.2-1.4.2-2.8 0-4.2-.4-2.5-1.3-4.8-2.7-6.6C17.5.4 13.3.2 9.7.7z",
  fill: "#fbe8c5",
  stroke: "#fff",
  strokeMiterlimit: 10
});

var SvgCircle = function SvgCircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 23.4 23.8",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/circle.c3942867.svg";
export { ForwardRef as ReactComponent };